<router-outlet></router-outlet>
<app-tenant-inactive-modal
  [visible]="authService.tenantInactiveVisible()"
  [tenantName]="authService.tenantInactiveTenantName()"
  (dismissed)="authService.dismissTenantInactive()"
/>
<app-user-inactive-modal
  [visible]="authService.userInactiveVisible()"
  [tenantName]="authService.userInactiveTenantName()"
  [tenantEmail]="authService.userInactiveTenantEmail()"
  (dismissed)="authService.dismissUserInactive()"
/>
